// extracted by extract-css-chunks-webpack-plugin
module.exports = {"center_box":"center_box-2F8qYPeE"};